exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".iframe__33-q {\n  width: 100%;\n  height: 300px;\n  border: 0 none;\n  overflow: hidden; }\n", "", {"version":3,"sources":["/app/src/control/sandbox/src/control/sandbox/sandbox.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB,EAClB","file":"sandbox.scss","sourcesContent":[".iframe {\n  width: 100%;\n  height: 300px;\n  border: 0 none;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"iframe": "iframe__33-q"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/control/sandbox/sandbox.scss
// module id = 840
// module chunks = 0